import script from "./works.vue?vue&type=script&setup=true&lang=js"
export * from "./works.vue?vue&type=script&setup=true&lang=js"

import "./works.vue?vue&type=style&index=0&id=5a13cb85&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a13cb85"]])

export default __exports__